export default __webpack_public_path__ + "static/media/VerifyPassPc.d89baf94.svg";